import { useState } from 'react'
import { Form } from 'antd'

const useAdmissionModal = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [form] = Form.useForm()

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
    form.resetFields()
  }

  const handleAdd = () => {
    form
      .validateFields()
      .then((values) => {
        // In a real application, this would add the new admission to the database
        // For this mock, we're just logging it
        setIsModalVisible(false)
        form.resetFields()
      })
      .catch((info) => {})
  }

  return {
    isModalVisible,
    form,
    showModal,
    handleCancel,
    handleAdd
  }
}

export default useAdmissionModal
